// Temporary AT-only test data, used until BankID test persons with addresses that have a valid VAID exist
export type TeliaPlayMockAddressDefinition = {
    id: number;
    vaid: number;
    street: string;
    apartment: string;
    postalCode: string;
    city: string;
};

export type TeliaPlayResolvedMockAddress = {
    id: number;
    vaid: number;
};

export type TeliaPlayMockPackage = {
    id: number;
    name: string;
};

export const TELIA_PLAY_MOCK_ADDRESSES: TeliaPlayMockAddressDefinition[] = [
    { id: 1, vaid: 4000177, street: "Apalveien 4", apartment: "H0101", postalCode: "3413", city: "Lier" },
    { id: 2, vaid: 25452254, street: "Rathkes Gate 13A", apartment: "H0202", postalCode: "0558", city: "Oslo" },
    { id: 3, vaid: 22778510, street: "Skjellmyrstubben 15", apartment: "H0101", postalCode: "2770", city: "Jaren" },
    { id: 4, vaid: 23335604, street: "Pelskroken 13", apartment: "H0101", postalCode: "6411", city: "Molde" },
    { id: 5, vaid: 23526063, street: "Mispelveien 14", apartment: "H0101", postalCode: "3152", city: "Tolvsrød" },
    {
        id: 6,
        vaid: 21821134,
        street: "Sigrid Undsets Veg 15",
        apartment: "H0101",
        postalCode: "7023",
        city: "Trondheim",
    },
    {
        id: 7,
        vaid: 21814026,
        street: "Martin Stokkens Veg 50",
        apartment: "H0101",
        postalCode: "7027",
        city: "Trondheim",
    },
    { id: 8, vaid: 21780059, street: "Furuvegen 17", apartment: "H0101", postalCode: "2069", city: "Jessheim" },
    { id: 9, vaid: 4465574, street: "Tyrihans 8", apartment: "H0101", postalCode: "3055", city: "Krokstadelva" },
    { id: 10, vaid: 4464585, street: "Ringveien 24B", apartment: "H0101", postalCode: "3050", city: "Mjøndalen" },
    { id: 11, vaid: 1978639, street: "Kollåsveien 46", apartment: "H0101", postalCode: "4900", city: "Tvedestrand" },
    {
        id: 12,
        vaid: 21791427,
        street: "Gamle Trondheimsveg 42",
        apartment: "H0101",
        postalCode: "2053",
        city: "Jessheim",
    },
];

export const TELIA_PLAY_MOCK_PACKAGES: TeliaPlayMockPackage[] = [
    { id: 232831376, name: "Telia Play stream Start" },
    { id: 962803814, name: "Telia Play stream Basic" },
    { id: 760357282, name: "Telia Play stream Max" },
];

export const formatMockAddress = ({
    vaid,
    street,
    apartment,
    postalCode,
    city,
}: TeliaPlayMockAddressDefinition): string => `VAID ${vaid} - ${street}, ${apartment}, ${postalCode} ${city}`;

export const formatMockPackage = ({ id, name }: TeliaPlayMockPackage): string => `${name} (${id})`;
